<template>
    <div class="page-wrap">
        <div class="page-bar">
            <div>
                <div class="page-bar-sub">Team</div>
                <div class="page-bar-main">Onboarding</div>
            </div>
        </div>
        <div :class="$store.state.routeLoaded ? 'slide-up view' : 'hide'">
            <div v-if="$store.state.user.teamHubRole == 'Admin'" class="page-filters pf-bar">
                <div @click="addNewOnboarding()" class="add-btn">Add</div>
            </div>
            <div>
                <div class="next-nodes-grid">
                    <div v-for="(onboarding, i) in onboardings" :key="i" v-show="!onboarding.hide" class="next-node-card-wrap">
                        <div class="next-node-card" @click="() => { $router.push('/onboarding/'+onboarding.ID) }">
                            <div class="next-node-card-top">
                                <div class="next-node-card-name">{{ onboarding.Name }}</div>
                                <button v-if="$store.state.user.teamHubRole == 'Admin'" type="button" class="next-node-menu-btn" @click.stop="toggleOnboardingMenu(onboarding, $event)">
                                    <svg-icon icon="dots" />
                                </button>
                            </div>
                        </div>
                        <div v-if="openOnboardingId == onboarding.ID" class="next-node-menu-dropdown" :style="onboardingMenuStyle" @click.stop>
                            <a @click.prevent="onboardingMenuAction(() => editOnboarding(onboarding))">Edit</a>
                            <a @click.prevent="onboardingMenuAction(() => showSignaturesFn(onboarding))">Signatures</a>
                            <a @click.prevent="onboardingMenuAction(() => deleteOnboarding(onboarding))">Delete</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <confirm-delete v-if="showConfirmDelete" @confirm="deleteConfirm" @cancel="() => { showConfirmDelete = false; }" msg="Are you sure you would like to delete this onboarding?"/>
        <add-edit-onboarding v-if="showAddEdit" :onboardingToEdit="onboardingToEdit" @close="() => { getOnboardings(); showAddEdit = false }" />
        <onboarding-signatures v-if="showSignatures" @close="() => { showSignatures = false }" :onboardingProp="signaturesOnboarding" />
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
import ConfirmDelete from '@/components/ConfirmDelete.vue';
import AddEditOnboarding from '@/components/AddEditOnboarding.vue';
import OnboardingSignatures from '@/components/OnboardingSignatures.vue';
import SvgIcon from '@/components/SvgIcon.vue';

export default defineComponent({
    name: 'OnboardingsView',
    components: {
        ConfirmDelete,
        AddEditOnboarding,
        OnboardingSignatures,
        SvgIcon
    },
    data() {
        return {
            onboardings: [] as any,
            showAddEdit: false,
            onboardingToEdit: null as any,
            onboardingIdToDelete: null as any,
            showConfirmDelete: false,
            showSignatures: false,
            signaturesOnboarding: null as any,
            openOnboardingId: null as any,
            onboardingMenuStyle: {} as any
        }
    },
    async created() {
        await this.getOnboardings();

        this.$store.state.routeLoaded = true;
    },
    methods: {
        async getOnboardings() {
            await axios.get(`${this.$store.state.apiUrl}/api/onboardings`)
                .then(resp => {
                    for(const onboarding of resp.data) {
                        onboarding.StepsJSON = JSON.parse(onboarding.StepsJSON);
                        const existingTeamLink = this.$store.state.user.teamHubLinks.find((link: any) => {
                            return link.link == `/onboarding/${onboarding.ID}`;
                        });
                        if(existingTeamLink) {
                            onboarding.hide = true;
                        }
                    }
                    this.onboardings = resp.data;
                })
                .catch(e => {
                    console.log(e);
                })
        },
        addNewOnboarding() {
            this.onboardingToEdit = null;
            this.showAddEdit = true;
        },
        editOnboarding(onboarding: any) {
            this.onboardingToEdit = onboarding;
            this.showAddEdit = true;
        },
        deleteOnboarding(onboarding: any) {
            this.onboardingIdToDelete = onboarding.ID;
            this.showConfirmDelete = true;
        },
        deleteConfirm() {
            this.showConfirmDelete = false;
            axios.delete(`${this.$store.state.apiUrl}/api/onboardings/${this.onboardingIdToDelete}`)
                .then(resp => {
                    this.getOnboardings();
                })
                .catch(e => {
                    console.log(e);
                    alert('There was an error')
                })
        },
        showSignaturesFn(onboarding: any) {
            this.signaturesOnboarding = onboarding;
            this.showSignatures = true;
        },
        toggleOnboardingMenu(onboarding: any, event: MouseEvent) {
            if(this.openOnboardingId == onboarding.ID) {
                this.openOnboardingId = null;
                return;
            }

            const margin = 10;
            const dropdownWidth = 200;
            const btn = event.currentTarget as HTMLElement;
            const wrap = btn.closest('.next-node-card-wrap') as HTMLElement;
            const rect = btn.getBoundingClientRect();
            const wrapRect = wrap.getBoundingClientRect();

            const top = Math.min(rect.bottom + 6, window.innerHeight - margin);

            this.onboardingMenuStyle = {
                top: (top - wrapRect.top) + 'px',
                left: '-10px',
                width: dropdownWidth + 'px',
                maxHeight: (window.innerHeight - top - margin) + 'px'
            };
            this.openOnboardingId = onboarding.ID;
        },
        closeOnboardingMenu() {
            this.openOnboardingId = null;
        },
        onboardingMenuAction(action: any) {
            this.closeOnboardingMenu();
            action();
        },
        handleOutsideOnboardingMenuClick(e: MouseEvent) {
            if(this.openOnboardingId && !(e.target as HTMLElement).closest('.next-node-card-wrap')) {
                this.openOnboardingId = null;
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.handleOutsideOnboardingMenuClick);
        window.addEventListener('resize', this.closeOnboardingMenu);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleOutsideOnboardingMenuClick);
        window.removeEventListener('resize', this.closeOnboardingMenu);
    }
});
</script>
